/**
 * @deprecated This component is deprecated. Use simple href links instead:
 * - For login: <a href="#login">Sign In</a>
 * - For register: <a href="#register">Create Account</a>
 *
 * The AccountDrawer is now rendered at the root level and responds to hash navigation.
 */
import React from 'react'
import {defaultAccountDrawerChildren} from './utils'
import modelMap from 'hec/builder/model-map'
import type {RegisteredComponent} from '@builder.io/sdk-react'

interface AccountDrawerProps {
    attributes?: Record<string, unknown>
    children?: React.ReactNode
    startWith?: 'login' | 'registration'
    accountFormLabels?: Record<string, unknown>
    checkoutPageReference?: Record<string, unknown>
    expandDrawerInEditor?: boolean
    enableGuestCheckout?: boolean
    onClose?: () => void
}

const BuilderAccountDrawer: React.FC<AccountDrawerProps> = ({children}) => {
    console.warn(
        'AccountDrawer component is deprecated. Use href="#login" or href="#register" instead.'
    )
    return children ? <>{children}</> : null
}

export default BuilderAccountDrawer

export const AccountDrawerDefinition = {
    component: BuilderAccountDrawer,
    name: 'AccountDrawer',
    hideFromInsertMenu: true, // Deprecated - use alternative #login and #register links
    noWrap: true,
    canHaveChildren: true,
    image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/user.svg',
    defaultChildren: defaultAccountDrawerChildren,
    inputs: [
        {
            name: 'startWith',
            type: 'string',
            enum: ['login', 'registration'],
            defaultValue: 'login'
        },
        {
            name: 'accountFormLabels',
            type: 'reference',
            model: modelMap.accountFormLabels,
            helperText: 'Select the account form labels to use'
        },
        {
            name: 'checkoutPageReference',
            friendlyName: 'Checkout page reference',
            type: 'reference',
            model: 'page'
        },
        {name: 'expandDrawerInEditor', type: 'boolean', defaultValue: false},
        {name: 'enableGuestCheckout', type: 'boolean', defaultValue: false}
    ]
} satisfies RegisteredComponent
